<template>
  <div class="translator-shell">
    <header class="translator-header d-flex align-items-center justify-content-between p-3 border-bottom">
      <div>
        <strong>👤 {{ username || 'Usuario' }}</strong>
      </div>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-secondary" @click="handleLogout">🚪 Logout</button>
      </div>
    </header>

    <main class="translator-main p-3">
      <Casos />
    </main>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import api from '../services/api.js'
import Casos from './Casos.vue'

const router = useRouter()
const username = ref('')

onMounted(() => {
  const u = api.getCurrentUser()
  username.value = u?.username || u?.user || ''
})

async function handleLogout() {
  try {
    await api.logout()
  } catch (e) {
    console.error('Logout error', e)
  } finally {
    // Redirect to login and reload to ensure app state resets
    router.replace('/login')
    // Small delay to let router navigate before full reload
    setTimeout(() => location.reload(), 60)
  }
}
</script>

<style scoped>
.translator-header { background: var(--bs-light); }
.translator-main { min-height: 60vh; }
</style>
